const  DeclareSoon = () => {
    return (<div className="flex justify-center items-center h-[70vh]">
    <p className="tetx-black">Will be Declared Soon</p>
    </div>);
}

export default DeclareSoon;